/* Maison Sabelle homepage: L'Objet. Entrance reveal, and a slow drift on the images and ghost word.
   Horizon scrolls .page-wrapper on desktop and the window on phones, so position is read from the element. */
(() => {
  const init = (root) => {
    if (root.dataset.sbfReady) return;
    root.dataset.sbfReady = '1';
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const img = root.querySelector('[data-sbf-drift]');
    const pack = root.querySelector('[data-sbf-float]');
    const ghost = root.querySelector('[data-sbf-ghost]');

    if (!reduce && 'IntersectionObserver' in window) {
      root.classList.add('is-armed');
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { root.classList.add('is-in'); io.disconnect(); } });
      }, { threshold: 0.2 });
      io.observe(root);
    }
    if (reduce) return;

    let ticking = false;
    const update = () => {
      ticking = false;
      const r = root.getBoundingClientRect();
      const vh = innerHeight;
      if (r.bottom < 0 || r.top > vh) return;
      // 0 as the section enters at the bottom, 1 as it leaves at the top.
      const p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
      if (img) img.style.setProperty('--sbf-d', `${(-10 + p * 8).toFixed(2)}%`);
      if (pack) pack.style.setProperty('--sbf-f', `${(60 - p * 120).toFixed(1)}px`);
      if (ghost) ghost.style.setProperty('--sbf-gx', `${(40 - p * 120).toFixed(1)}px`);
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    addEventListener('scroll', onScroll, { passive: true });
    document.querySelector('.page-wrapper')?.addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll);
    update();
  };
  const boot = () => document.querySelectorAll('[data-sbf]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
